import React, { Component, push } from "react";
import { withRouter } from "react-router-dom";
import {
  Grommet,
  Box,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
  Layer,
  Accordion,
  AccordionPanel,
  Spinner,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Console,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Close,
  Clipboard,
  StatusInfo,
} from "grommet-icons";
import { CopyToClipboard } from "react-copy-to-clipboard";

class ShareContentMessage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.url,
      copied: false,
    };
  }
  componentDidMount() {}

  render() {
    if (this.state.copied) {
      this.props.hide();
    }
    return (
      <Main flex="grow" fill="vertical" overflow="auto">
        <Layer animate modal={false}>
          <Box align="center" justify="center">
            <Box
              align="center"
              justify="center"
              background={{ color: "brand" }}
              fill="horizontal"
            >
              <Box
                align="center"
                justify="between"
                direction="row"
                gap="medium"
                fill="horizontal"
              >
                <StatusInfo size="large" color="white" />
                <Heading size="small" level="1" margin="small">
                  Share content URL
                </Heading>
                <Button icon={<Close />} secondary onClick={this.props.hide} />
              </Box>
            </Box>
            <Box align="center" justify="center" direction="row" gap="xsmall">
              <Heading size="small" level="4" margin="small" truncate>
                {this.props.url}
              </Heading>
            </Box>
            <Box
              align="center"
              justify="center"
              direction="row"
              gap="large"
              margin="medium"
            >
              <CopyToClipboard
                text={this.props.url}
                onCopy={() => this.setState({ copied: true })}
              >
                <Button
                  label={this.state.copied ? "copied" : "copy to clipboard"}
                  active={false}
                  disabled={this.state.copied}
                  reverse={false}
                  type="button"
                  icon={<Clipboard />}
                  primary
                  hoverIndicator
                />
              </CopyToClipboard>
            </Box>
          </Box>
        </Layer>
      </Main>
    );
  }
}

export default ShareContentMessage;
